$(document).on('click', '.story__video-play-cion, .story__video', function (e) {
  e.stopPropagation(); 
  e.preventDefault();  

  const $wrap = $(this).closest('.story__video-wrap');
  const $video = $wrap.find('video');
  const videoEl = $video.get(0);
  const $playBtn = $wrap.find('.story__video-play-cion');

  if (!videoEl) return;

  if (videoEl.paused) {
    videoEl.play();
    $playBtn.addClass('playing').hide(); 
  } else {
    videoEl.pause();
    $playBtn.removeClass('playing').show(); 
  }
});




if ($(window).width() > 768) {
    $(".video__item-video").on("click", function () {
        var video_src = $(this).parent().attr("data-video-embed");
        const classList = $(this).attr("class").split(" ");

        let parent = $(this).closest(".video__item").find(".video__bot-wrap");
            let image = parent.find(".video__channel-img img").attr("src");
            let title = parent.find(".video__channel-name h3").text();
            let sub_title = parent.find(".video__channel-name p").text();
            
         $(".video__desk-channel-img img").attr("src", image);
          $(".video__desk-channel-name h3").text(title);
          $(".video__desk-channel-name p").text(sub_title);

        if (video_src.includes("youtube") || video_src.includes("vimeo")) {
            video_src += (video_src.includes("?") ? "&" : "?") + "autoplay=1";
        }

        // Update the iframe inside .video__desk-video
        $(".video__desk-video iframe").attr("src", video_src);
    });
}










if ($(window).width() < 768) {

    $(".video__hosted").click(function () {
        var video = $(this).find("video").get(0);
        var icon_image = $(this).find(".video__play-icon");

        if (video.paused) {

            $("video").each(function () {
                this.pause();
                $(".video__play-icon").css("display", "block");
            });

            $(".video__youtube iframe").each(function () {
                var src = $(this).attr("src");
                $(this).attr("src", src);
            });

            video.play();
            icon_image.css("display", "none");
        } else {
            video.pause();
            icon_image.css("display", "block");
        }
    });


// $(".ytmCuedOverlayPlayButton").on("click",function(){
//     alert();
// })




}




// video-slider start





$('.video-slider__first-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    fade:true,
});


$('.video-slider__second-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    fade:true,
});


$('.video-slider__third-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    fade:true,
});

$('.video-slider__four-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 6000,
    fade:true,
});





// video-slider end



var pre_order_price = $('[s-type="pre-order"]').attr('price');
var ship_now_price = $('[s-type="ship-now"]').attr('price');

$(document).on('change', '.variant-picker', function() {
  $('.product-variant-id').val($(this).val());
  var $parent = $(this).parent();
  var purchasePrice = $parent.find('.purchase-price').text();
  var sale_type = $(this).attr('s-type');

  $('.reg-price').text(purchasePrice);
  if(sale_type == 'ship-now'){
    $('.price__sale').hide();
    $('.price__badge-sale').hide();
    $('.price__regular').show();
    $('.price-item--regular').css('text-decoration', 'none');
  }else{
    $('.price__sale').show();
    $('.price__badge-sale').show();
    $('.price__regular').hide();
    $('.price-item--regular').css('text-decoration', 'line-through');
  }

});

$(document).ready(function () {
  var selectedValue = $('.variant-picker:checked').val();
  
  if (selectedValue) {
    $('.product-variant-id').val(selectedValue);
     $('.price__sale').hide();
    $('.price__regular').show();
    $('.price-item--regular').css('text-decoration', 'none');
    $('.reg-price').text($('.variant-picker:checked').attr('price'));
    $('.price__badge-sale').hide();
  }
});

/* Auto-redirect Canadian (CA) IP visitors to the CAD /en-ca storefront.
   Runs on EVERY page view - Canadians are always sent to the Canada site.
   Reuses the theme's existing ipinfo.io geo-detection, which adds body.country_ca. */
(function () {
  try {
    if (window.Shopify && window.Shopify.designMode) return;      // skip in theme editor
    var path = window.location.pathname || '/';
    if (path.indexOf('/en-ca') === 0) return;                     // already on the CAD store
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (document.body && document.body.classList.contains('country_ca')) {
        clearInterval(iv);
        window.location.replace('/en-ca' + path + window.location.search);
      } else if (tries > 50) { clearInterval(iv); }               // stop after ~10s
    }, 200);
  } catch (e) {}
})();

/* Meta pixel "Lead" on Alia popup signup (official Alia SDK event "alia:signup").
   Added 2026-07-30 (Claude, at Ben's direction). Pixel 541711751451947.
   Shopify's Meta channel pixel runs sandboxed (no window.fbq on the page), so this
   lazily loads its own fbevents.js AT SIGNUP TIME ONLY - zero footprint for normal
   visitors, and it reuses the existing _fbp/_fbc cookies for ad-click attribution.
   Fires with advanced matching (email/phone auto-hashed by Meta client-side) and an
   eventID prefixed "alia-" reserved for future Conversions API deduplication. */
(function () {
  var PIXEL_ID = '541711751451947';
  document.addEventListener('alia:signup', function (e) {
    try {
      var d = (e && e.detail) || {};
      if (!window.fbq) {
        !function(f,b,ev,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(ev);t.async=!0;t.src=v;s=b.getElementsByTagName(ev)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      }
      var am = {};
      if (d.email) am.em = String(d.email).trim().toLowerCase();
      if (d.phone) am.ph = String(d.phone).replace(/\D/g, '');
      window.fbq('init', PIXEL_ID, am);
      var eventID = 'alia-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
      window.fbq('trackSingle', PIXEL_ID, 'Lead',
        { content_name: 'Alia Popup Signup', content_category: 'Email Signup' },
        { eventID: eventID });
    } catch (err) {}
  });
})();
